export const projectPath = (id, isWorkflowGroup) =>
  isWorkflowGroup ? `/project/consolidated/${id}` : `/project/quaters/${id}`;

export const dashboardPath = (workflowId, project) =>
  project?.workflow_group_id
    ? `${projectPath(project.workflow_group_id, true)}?projectId=${workflowId}`
    : projectPath(workflowId, project?.is_workflow_group);
